import React from 'react'
import popup from "~/views/Popup/popup"
import { getToken } from '~/redux/user/tokens'
import { axiosWithKey } from "~/axios"
import { userLanguageSelector } from '~/tools/localization'
import { trackECommerceEvent } from "~/tools/analytics/googleAnalytics";
import Spinner from '~/components/Spinner'
import Cookies from 'js-cookie'
import './style.css'
import StripeCallback from '~/components/StripeiDealForm/StripeCallback';
import { StripeJS } from '~/views/Popup/views/CreateSubscription/Billing/StripeCCForm/StripeJS'

// const  titleMap = {
//   'createAccount': [this.props.metadataMap.createAccount, this.props.metadataMap.accountCreated],
//   'billing': [this.props.metadataMap.addBilling, this.props.metadataMap.addedBilling],
//   'verify': [this.props.metadataMap.verifyPay]
// }

class ThankYou extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      current: props.user ? props.user.billingInfo ? 'verify': 'billing' : 'createAccount',
      plan: props.args.plan,
      content: props.args.content,
      type: props.args.type,
      metadataMap:{},
      loading: true
    }
  }

  isComplete(state) {
    return (
      (state === 'createAccount' && this.state.user) ||
      (state === 'billing' && this.state.user && this.state.user.billingInfo) ||
      (state === 'verify' && false)
    )
  }

  async componentDidMount() {
    await StripeJS()
    this.fetchPageData()
  }

  fetchPageData = () =>{
    getToken(token => {
      return axiosWithKey({
        method: "GET",
        url: `${window.settings.apiBaseUrlCached || window.settings.apiBaseUrl}/content/pages?path=/subscribe&languageCode=${userLanguageSelector()}&includeContent=true`,
        headers: { Authorization: token }
      })
        .then(res => {
          const response = res.data.modules[0].metadataMap
          this.setState({metadataMap: response, loading: false})
        })
        .catch();
    });
  }
  handleClose() {
    Cookies.remove('isiDealPayment')
    popup.hide()
    window.location.href = "/";
  }


  componentDidUpdate(prevProps, prevState){
    const { content } = this.state
    const currencyCode = content && content.pricing && content.pricing.currency
    if(this.state.current !== prevState.current){
      if (this.state.current === 'billing'){
        this.ga("set", "currencyCode", currencyCode);
        trackECommerceEvent("ec:addProduct", {
          id: this.state.plan.videoID,
          name: this.state.plan.name,
          price: this.state.plan.price,
          quantity: 1
        });
        this.ga("ec:setAction", "checkout", { step: 2 });
        this.ga("send", "event", "e-commerce", "checkout-step", '2');
        this.dataLayer.push({
          event: "tvod_purchase_checkout_step_2",
          tvod_content_uuid: this.state.plan.videoID,
          tvod_content_name: this.state.plan.name,
          tvod_content_price: this.state.plan.price
        });
      }
      if(this.state.current === 'verfiy') {
        this.ga("set", "currencyCode", currencyCode);
        trackECommerceEvent("ec:addProduct", {
          id: this.state.plan.videoID,
          name: this.state.plan.name,
          price: this.state.plan.price,
          quantity: 1
        });
        this.ga("ec:setAction", "checkout", { step: 3 });
        this.ga("send", "event", "e-commerce", "checkout-step", "3");
        this.dataLayer.push({
          event: "tvod_purchase_checkout_step_3",
          tvod_content_uuid: this.state.plan.videoID,
          tvod_content_name: this.state.plan.name,
          tvod_content_price: this.state.plan.price
        });
      }
      if(this.state.current === 'thankyou'){
        this.ga("set", "currencyCode", currencyCode);
        trackECommerceEvent("ec:addProduct", {
          id: this.state.plan.videoID,
          name: this.state.plan.name,
          price: this.state.plan.price,
          quantity: 1
        });
        this.ga("ec:setAction", "purchase", { 
          id: this.state.user.billingInfo.requestId,
          revenue: this.state.plan.price
        });
        this.ga("send", "event", "e-commerce", "purchase");
        this.dataLayer.push({
          event: "tvod_purchase_completion",
          tvod_content_uuid: this.state.plan.videoID,
          tvod_content_name: this.state.plan.name,
          tvod_content_price: this.state.plan.price,
          transaction_id: this.state.user.billingInfo.requestId
        });
      }
    }
  }
 

  render() {
    if (this.state.loading)
      return (<div className="loading centered"><Spinner/></div>)
    
      return (
        <div className="iDealComponents">
          <div className="close-button" onClick={this.handleClose.bind(this)}><i className="ion-ios-close-empty"/></div>
          <StripeCallback fields={this.state.metadataMap} />
        </div>
      )
  }
   
}


export default ThankYou;